import React from 'react';
import { Helmet } from 'react-helmet';
import { Grid, Header, Image, Segment, Button } from 'semantic-ui-react';
// import HeaderBlock from './HeaderBlock';
import HeaderSmall from './HeaderSmall';
import FooterBlock from './FooterBlock';
//import Signup from './Signup';
import TribeVibeLogo from '../assets/tribevibe-drumbeat-logo-208.png';

const Landing = () => (
  <div>
    <Helmet defer={false}>
      <title>TribeVibe - Home - See the new project!</title>
    </Helmet>
    {/* <HeaderBlock /> */}
    <HeaderSmall />
    <Segment style={{ padding: '6em 0 6em 0em' }} vertical>
      <Grid container stackable verticalAlign="middle">
        <Grid.Row>
          <Grid.Column width={8}>
            <Header as="h3" style={{ fontFamily: 'PT+Sans', fontSize: '2em' }}>
              Chalk It Up To Experience
            </Header>
            <p style={{ fontSize: '1.2em' }}>
            TribeVibe was a social search and analytics startup based out of Boulder Colorado. Thanks to everyone who supported it and tried it out.</p>
            <p style={{ fontSize: '1.2em' }}>Some of our tribe are working on a new project based on what we learned about search and personalisation. 
            It's called <a href="https://andisearch.com/">Andi</a>, and it's pretty cool.</p>
            
            <Header as="h3" style={{ fontFamily: 'PT+Sans', fontSize: '2em' }}>
              Up Next - <a href="https://andisearch.com/">Andi!</a>
            </Header>
            <Button style={{marginTop: '18px', borderRadius: '16px'}} size="huge" color="orange" as="a" href="https://andisearch.com" content="Try a search with Andi now! 🤩 🤖 🔍"/>
            <p style={{ marginTop: '24px', fontSize: '1.2em' }}>Check out <a href="https://andisearch.com/">Andi</a>. It's a radical new search engine that is anonymous, ad-free and no tracking, and uses a completely new type of approach to search.</p>
            <Header as="h3" style={{ fontFamily: 'PT+Sans', fontSize: '2em' }}>
                Love the tribevibe.com domain?
            </Header>
            <p style={{ fontSize: '1.2em' }}>
                This domain may be for sale:  <a href="mailto:brian@gritbrokerage.com">brian@gritbrokerage.com</a>
            </p>
          </Grid.Column>
          <Grid.Column floated="right" width={4}>
            <Image
              // bordered
              rounded
              size="medium"
              src={TribeVibeLogo}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Segment>
    {/* <Signup /> */}
    <FooterBlock />
  </div>
);

export default Landing;



// WEBPACK FOOTER //
// ./src/components/Landing.js